module.exports =
  '_COMMON_FOOTER':
    'TERM_OF_SERVICE': 'Terms of Service'
    'PRIVACY_POLICY' : 'Privacy Policy'
    'LEGAL' : 'Legal Information'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-footer/i18n/en.coffee